import React, { useEffect } from 'react';
import axios from 'axios';
import { format } from 'date-fns';
import RegionHeader from './RegionHeader';
import { getDefaultDate } from './routines'

export default function TimeSeriesGraphTable(props) {
  const { date, handleButtonClick } = props;
  const monyr = date ? date : getDefaultDate();
  const [ sfdata, setSfdata ] = React.useState({});
  const buttontext = "Graph View";
	const buttonValue = ("timeseriesgrf");
  const indices = {
    "precip": "Precipitation",
    "sf": "Streamflow",
    "gw": "Groundwater",
    "eddi": "Evapotranspiration",
  };

  // get data date keys (last 12 months)
  const [ syear, smonth ] = monyr.split("-")
  const tdate = new Date(parseInt(syear), parseInt(smonth) - 1, 1);
  const date_keys = [];
  const date_labels = [];
  for (let i = 0; i < 12; i++) {
    date_keys.push(`${tdate.getFullYear()}-${tdate.getMonth() + 1}`);
    date_labels.push(format(tdate, 'MMM yyyy'))
    tdate.setMonth(tdate.getMonth() - 1);
  }

  const dataFileName = (window.location.hostname === "localhost" ? "." : "/ma") + "/data/regional_timeSeries_"+monyr+".json";

  useEffect(() => {
    axios.get(dataFileName)
    .then(results => {
      setSfdata(results.data)
    })
    .catch(err => {
        console.log(err.message);
    });
  }, [dataFileName]);


  return (
    <>
      <RegionHeader
				title={"Time Series Summary"}
				buttontext={buttontext}
				buttonValue={buttonValue}
				handleButtonClick={handleButtonClick}
      />
      {Object.keys(sfdata).length > 0 &&
        <table className="pcpnTable-container">
          <caption>
            Time Series of Index Percentiles
          </caption>
          <thead>
            <tr>
              <th scope="col">Region</th>
              <th scope="col">Indicator</th>
              {date_labels.toReversed().map( dk => (
                <th scope="col" key={dk}>{dk}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Object.keys(sfdata).map( region => (
              Object.keys(sfdata[region]).map( indicator => (
                <tr key={region+indicator}>
                  <td>{region.replace("Connecticut River","CTRV")}</td>
                  <td>{indices[indicator]}</td>
                  {date_keys.toReversed().map( dk => (
                    <td key={dk}>{sfdata[region][indicator][dk] ? sfdata[region][indicator][dk] : "NA"}</td>
                  ))}
                </tr>
              ))
            ))}
          </tbody>
        </table>
  }
    </>
  );
}
